import { render } from "./McpServerRequestOverlay.vue?vue&type=template&id=3586a407&ts=true"
import script from "./McpServerRequestOverlay.vue?vue&type=script&lang=ts"
export * from "./McpServerRequestOverlay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__